module.exports = "/dist/src/img/logo.png";